module.exports = __webpack_public_path__ + "fonts/Manrope-600-vietnamese16.d255f9e.woff2";